
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Durchschnittlich verlieren wir pro Nacht einen Liter Feuchtigkeit. Das feuchtwarme Klima, das in unseren Daunen herrscht, ist darum eine ideale Brutstätte für Bakterien, Milben und Pilze. `}<M mdxType="M">{`Daher empfiehlt es sich, die Bettwäsche alle zwei Wochen oder mindestens alle drei Wochen zu wechseln.`}</M>{` Wer viel schwitzt oder gerade mit Erkältung im Bett war, sollte die Wäsche gar wöchentlich wechseln. Sinnvoll ist es auch, immer wieder einmal die Matratze zu wenden. Für Milben-Allergiker lohnt es sich, die Bettwäsche mit milbendichten Überzügen einzupacken. So wird verhindert, dass in der Nacht allergischer Schnupfen, Augenreizungen oder Asthma ausbrechen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;